var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"convention-sections-lines"},[_c('div',{staticClass:"line line1"}),_c('div',{staticClass:"line line2"}),_c('div',{staticClass:"line line3"}),_c('div',{staticClass:"line line4"}),_c('div',{staticClass:"line line5"})])
}]

export { render, staticRenderFns }